import { render } from "./ServiceDetails.vue?vue&type=template&id=63af11ea&scoped=true"
import script from "./ServiceDetails.vue?vue&type=script&lang=js"
export * from "./ServiceDetails.vue?vue&type=script&lang=js"

import "./ServiceDetails.vue?vue&type=style&index=0&id=63af11ea&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63af11ea"]])

export default __exports__